import { render, staticRenderFns } from "./ManualImport.vue?vue&type=template&id=2bd871d2&"
import script from "./ManualImport.vue?vue&type=script&lang=js&"
export * from "./ManualImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports